/**
 * Returns a list with distinct items based on a property
 * @param list original list
 * @param property object's unique property (could be empty for primitives)
 * @returns list with distinct items
 */

export function uniqueList<T>(list: T[], property?: string): T[] {
  const uniqueIds = new Set();
  const getId = (item) => (property ? item[property] : item);

  return list.filter((item) => {
    if (uniqueIds.has(getId(item))) {
      return false;
    }

    uniqueIds.add(getId(item));
    return true;
  });
}
